import { useMemo, useSyncExternalStore } from "react"
import { useLocation } from "react-router-dom"
import { useAuthStore } from "@/store/auth"
import {
  isMarketingCaptureRuntimeEnabled,
  isMarketingCaptureUnlocked,
  subscribeMarketingCaptureUnlock,
  wantsMarketingCapture,
} from "./guard"

export function useMarketingCapture() {
  const { pathname, search } = useLocation()
  const loggedIn = useAuthStore((state) => state.loggedIn)
  const unlocked = useSyncExternalStore(
    subscribeMarketingCaptureUnlock,
    isMarketingCaptureUnlocked,
    () => false
  )
  const runtime = isMarketingCaptureRuntimeEnabled()
  const wants = useMemo(() => wantsMarketingCapture(pathname, search), [pathname, search])

  const allowed = Boolean(loggedIn && runtime && wants && unlocked)
  const needsGate = Boolean(loggedIn && runtime && wants && !unlocked)

  return { allowed, needsGate, wants, runtime }
}
